import { Link } from 'react-router-dom'
import { PublicLegalLayout } from '@/components/layout/PublicLegalLayout'
import { AppLayout } from '@/components/layout/AppLayout'
import { FeedbackForm } from '@/components/feedback/FeedbackForm'
import { useMinCopy } from '@/i18n/useUiLocale'
import { useAuthStore } from '@/store/authStore'

export function FaqPage() {
  const isAuthenticated = Boolean(useAuthStore((state) => state.accessToken))
  const copy = useMinCopy({ preferGuest: !isAuthenticated })
  const faq = copy.faq

  const body = (
    <div className={isAuthenticated ? 'mx-auto max-w-2xl' : 'mx-auto max-w-2xl px-4 py-10 sm:px-6 sm:py-14'}>
      {!isAuthenticated ? (
        <p className="text-sm text-muted-foreground">
          <Link to="/" className="hover:text-foreground">
            {copy.brand.name}
          </Link>
          <span className="mx-2">/</span>
          {faq.breadcrumb}
        </p>
      ) : null}
      <h1
        className={
          isAuthenticated
            ? 'text-2xl font-semibold tracking-tight text-foreground sm:text-3xl'
            : 'mt-3 text-3xl font-semibold tracking-tight text-foreground sm:text-4xl'
        }
      >
        {faq.title}
      </h1>
      <p className="mt-3 text-sm leading-relaxed text-muted-foreground sm:text-base">
        {faq.intro}
      </p>

      <div className="mt-8 space-y-3" data-testid="faq-list">
        {faq.items.map((item) => (
          <details
            key={item.id}
            className="group rounded-xl border border-border/70 bg-card/70 px-4 py-3"
            data-testid={`faq-item-${item.id}`}
          >
            <summary className="cursor-pointer list-none text-sm font-medium text-foreground marker:content-none [&::-webkit-details-marker]:hidden">
              <span className="flex items-start justify-between gap-3">
                <span>{item.question}</span>
                <span className="mt-0.5 text-muted-foreground transition-transform group-open:rotate-45">+</span>
              </span>
            </summary>
            <p className="mt-3 text-sm leading-relaxed text-muted-foreground">{item.answer}</p>
          </details>
        ))}
      </div>

      <section className="mt-12 rounded-xl border border-border/70 bg-card/70 px-4 py-5 sm:px-5">
        <h2 className="text-lg font-semibold text-foreground">{faq.feedbackTitle}</h2>
        <p className="mt-1 text-sm text-muted-foreground">{faq.feedbackHint}</p>
        <div className="mt-4">
          <FeedbackForm pagePath="/faq" preferGuestLocale={!isAuthenticated} />
        </div>
      </section>
    </div>
  )

  if (isAuthenticated) {
    return <AppLayout>{body}</AppLayout>
  }

  return <PublicLegalLayout>{body}</PublicLegalLayout>
}
